// INITIAL_SESSION supplies the restored session. Subsequent SIGNED_IN and
// TOKEN_REFRESHED events for that identity must not reload the entire workspace.
export function subscribeWorkspaceIdentity(auth,onIdentity){
  let previous=Symbol('uninitialized');
  const {data:{subscription}}=auth.onAuthStateChange((_event,session)=>{
    const user=session?.user||null;
    const id=user?.id||null;
    if(id===previous)return;
    previous=id;
    onIdentity(user);
  });
  return ()=>subscription.unsubscribe();
}
